import React from 'react'
import TimelineWidget1 from './TimelineWidget1'
import timeline from '../json/timeline.json'

const SampleTimelineWidget1 = () => <TimelineWidget1 items={timeline} />

export default SampleTimelineWidget1
